import React from 'react';
import { SKELETON_STYLE } from '../../theme';

function SkeletonLoader({ count = 3, height = 80, style = {} }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          style={{
            ...SKELETON_STYLE,
            height,
            marginBottom: 8,
            ...style,
          }}
        />
      ))}
    </>
  );
}

export default SkeletonLoader;
